// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../actions';

// CUSTOM COMPONENTS
import { FluidSection } from '../components/FluidSection';
import { StretchCard } from '../components/StretchCard';
import { Content } from '../components/Content';
import StyledLink from '../components/StyledLink';
import { constants } from '../constants';
import SearchFilter from '../components/Search/SearchFilter';
import HeroSearch from '../components/Search/HeroSearch';
import ServiceCard from '../components/ServiceCard/ServiceCard';
import ProviderCardSection from '../components/ProviderCardSection/index';

// VENDOR COMPONENTS
import MenuItem from 'material-ui/MenuItem';

import { BrowserRouter as Router, withRouter } from 'react-router-dom';

// VENDOR UTILS
// import createHistory from 'history/createBrowserHistory';

class App extends Component {
    state = {
        serviceCategoryValues: [],
    };
    
    handleListSelectionChange = (event, index, serviceCategoryValues = []) => this.setState({serviceCategoryValues});

    constructor(props){
        super(props);
        
        this.state = {
            showModal: false,
            scrollToTop: false,
            showSchedule: false,
            showSearchFilter: false,
          };
    }
    
    componentDidMount(){
        document.getElementById('top').scrollIntoView();
        
        // Must load these here not in index for some reason for them to work 
        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
    }

    menuItems(serviceCategoryValues) {
        // console.log('service cat befor', this.props.serviceCategories)
        if ( this.props.serviceCategories ){
            // console.log('service cat', this.props.serviceCategories)
            return this.props.serviceCategories.map((serviceCategory) => (
              <MenuItem
                key={serviceCategory._id}
                // insetChildren={true}
                checked={serviceCategoryValues && serviceCategoryValues.indexOf(serviceCategory.description) > -1}
                value={serviceCategory.description}
                primaryText={serviceCategory.description}
              />
            ));
        }
    }
    
    // handleCloseSearchFilter = (event) => {
    //     console.log('Closing search');
    //     this.props.history.push(`/`)
    //     this.props.updateLocation("/");

    //     this.setState({serviceCategoryValues: [], showSearchFilter: false})
    // }

    render() {
        // const { history } = this.props;
        // // Get the current location.
        // const location = history.location
        
        // if (location.pathname === '/search' && !this.state.showSearchFilter){
        //     this.setState((prevState)=>({
        //         showSearchFilter: true
        //     }), () => {
        //         console.log('showSearchFilter set to true.');
        //     });
        // } else if (location.pathname === '/' && this.state.showSearchFilter) {
        //     this.setState((prevState)=>({
        //         showSearchFilter: false
        //     }), () => {
        //         console.log('showSearchFilter set to false.');
        //     });
        // }

        const {serviceCategories} = this.props;
        const {serviceCategoryValues} = this.state;
        
        let filteredServices = [];
        if (this.props.services && this.props.serviceCategories) { 
                filteredServices = this.props.services.filter(service => {
                    let categoryMatch = false;
                    
                    for (let categoryId in service.categories) {
                        if (categoryId) {
                            this.props.serviceCategories.map(category => {
                                let categoryDescription = null;
                                if (category._id === categoryId){
                                    categoryDescription = category.description
                                }
                                if (serviceCategoryValues && serviceCategoryValues.indexOf(categoryDescription) > -1) {
                                    if (categoryId === category._id) {
                                        categoryMatch = true;
                                    }
                                }
                            })
                        }
                    }
                        
                    return categoryMatch;
                }
            );
        }
        let unFilteredServices = [];

        if (this.props.services && this.props.serviceCategories) { 
                unFilteredServices = this.props.services.filter(service => {
                    let categoryMatch = false;
                        for (let categoryId in service.categories) {
                            if (categoryId) {
                                this.props.serviceCategories.map(category => {
                                    let categoryDescription = null;
                                    if (category._id === categoryId){
                                      categoryDescription = category.description
                                    }
                                    if ( !(serviceCategoryValues && serviceCategoryValues.indexOf(categoryDescription) > -1)) {
                                       if (categoryId === category._id) {
                                           categoryMatch = true;
                                       }
                                    }
                                })
                            }
                        }
                    return categoryMatch;
                }
            );
        }

        return (
            <div style={constants.layout.container}>

                <HeroSearch></HeroSearch>

                { filteredServices && ( serviceCategoryValues && serviceCategoryValues.length > 0 ) &&
                
                    <div>
                        <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={300} sectionMaxWidth={590}>
                            { filteredServices && 
                                filteredServices.map((service)=>{
                                    const filteredProviderCompanyCards = this.props.providers.map(provider => {
                                        if (service.provider === provider.uid){
                                            const serviceProviderCompanyCards = this.props.companies.map(company => {
                                                console.log(`%c${JSON.stringify(provider)}`,'color: blue');
                                                if (service.company === company._id){
                                                    return (
                                                        <ServiceCard
                                                            service={ service }
                                                            provider={ provider }
                                                            company={ company }
                                                        />
                                                    );
                                                }
                                            })
                                            return serviceProviderCompanyCards.filter(card => card);
                                        }
                                    })
                                    return filteredProviderCompanyCards.filter(card => card);
                                })
                            }
                            <div style={{minWidth: 300, maxWidth: 590}}/>
                        </FluidSection>
                    </div>
                }

                { unFilteredServices && (unFilteredServices.length > 0) &&
                    <div>
                        <FluidSection style={{ marginBottom: -25, paddingBottom: 0, }}>
                            <Content 
                                subTitleText={(unFilteredServices.length > 0) ? 'All Services' : 'Top Services'}
                            />
                        </FluidSection>

                        <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={300} sectionMaxWidth={590}>
                            { unFilteredServices.length > 0 && this.props.providers &&  
                                unFilteredServices.map((service)=>{
                                    const filteredProviderCompanyCards = this.props.providers.map(provider => {
                                        if (service.provider === provider.uid){
                                            const serviceProviderCompanyCards = this.props.companies.map(company => {
                                                if (service.company === company._id){
                                                    return (
                                                        <ServiceCard
                                                            service={ service }
                                                            provider={ provider }
                                                            company={ company }
                                                        />
                                                    );
                                                }
                                            })
                                            return serviceProviderCompanyCards.filter(card => card);
                                        }
                                    })
                                    return filteredProviderCompanyCards.filter(card => card);
                                }) 
                            }
                            <div style={{minWidth: 300, maxWidth: 590}}/>
                        </FluidSection>
                    </div>
                }
                <FluidSection style={{ marginBottom: -25, paddingBottom: 0, }}>
                    <Content 
                        subTitleText={'Top Experts'}
                    />
                </FluidSection>

                <ProviderCardSection
                    services={this.props.services}
                    providers={this.props.providers}
                />

                <FluidSection style={{ marginTop: 0, paddingTop: 0 }}>
                    <StyledLink
                        color={'#4AC4D1'}
                        letterSpacing={0.08}
                        to={'expert-search'} 
                        fontSize={14}
                    >
                        Search&nbsp;Experts
                    </StyledLink>
                </FluidSection>
            </div>
        );
    }
}

const mapStateToProps = ({provider, expert, service, company, auth, router}) => ({
    providers: provider.providers,
    services: service.services,
    serviceCategories: service.categories,
    serviceModules: service.serviceModules,
    companies: company.providerCompanies,
    emailIsVerified: auth.verificationStatus,
    emailVerified: auth.authData.emailVerified,
    userId: auth.authData && auth.authData.uid,
    location: router.location,
})

export default withRouter(connect(mapStateToProps, actions)(App));



// WEBPACK FOOTER //
// ./src/js/containers/Marketplace.jsx